import Vue from 'vue';
import VueFileAgent from 'vue-file-agent';

Vue.use(VueFileAgent);

export default VueFileAgent
